import { _defineProperty } from "./index13.js";
import { Side } from "./index50.js";
import { Vectors } from "@project-rouge/rg-three";
import { Vector3 } from "three";
var tol = 1e-5;
var _startToEnd = new Vector3();
var ThreadData = class ThreadData {
	get isSingleLoad() {
		return !!this.load;
	}
	constructor(props) {
		_defineProperty(this, "context", void 0);
		_defineProperty(this, "plotIndex", void 0);
		_defineProperty(this, "size", 0);
		_defineProperty(this, "bidirectional", void 0);
		_defineProperty(this, "boundary", void 0);
		_defineProperty(this, "holes", void 0);
		_defineProperty(this, "dir", void 0);
		_defineProperty(this, "nDir", void 0);
		_defineProperty(this, "start", void 0);
		_defineProperty(this, "end", void 0);
		_defineProperty(this, "right", void 0);
		_defineProperty(this, "sidePoints", void 0);
		_defineProperty(this, "startThread", void 0);
		_defineProperty(this, "endThread", void 0);
		_defineProperty(this, "load", void 0);
		_defineProperty(this, "depth", void 0);
		_defineProperty(this, "depthRight", void 0);
		_defineProperty(this, "depthLeft", void 0);
		_defineProperty(this, "tryTrimStart", void 0);
		_defineProperty(this, "shrinkDiff", 0);
		this.context = props.context;
		this.plotIndex = props.plotIndex;
		this.bidirectional = props.bidirectional;
		this.holes = props.holes;
		this.boundary = props.boundary;
		this.load = props.load;
		this.start = props.start;
		this.end = this.start.clone();
		this.dir = props.dir;
		this.nDir = this.dir.clone().negate();
		this.right = this.dir.clone().cross(Vectors.Up);
		this.tryTrimStart = props.tryTrimStart;
		this.depth = this.isSingleLoad ? this.context.singleLoadDepth : this.context.doubleLoadDepth;
		const { left, right } = ThreadData.getDepths(this.context, props.load);
		this.depthLeft = left;
		this.depthRight = right;
		this.sidePoints = [this.start.clone().addScaledVector(this.right, -this.depthLeft), this.start.clone().addScaledVector(this.right, this.depthRight)];
	}
	get isMain() {
		return !!this.bidirectional;
	}
	save({ data, start }) {
		let right = data.startThread.right;
		if (start) right = !right;
		if (start) this.startThread = {
			thread: data,
			right
		};
		else this.endThread = {
			thread: data,
			right
		};
	}
	toJSON() {
		throw new Error("not implemented");
	}
	fromJSON() {
		throw new Error("not implemented");
	}
	static getDepths(context, load) {
		if (!load) return {
			left: context.doubleLoadDepth * .5,
			right: context.doubleLoadDepth * .5
		};
		const isRight = load === Side.right;
		return {
			left: !isRight ? context.doubleLoadDepth * .5 : context.corridorDepth * .5,
			right: isRight ? context.doubleLoadDepth * .5 : context.corridorDepth * .5
		};
	}
	getMainBranch() {
		var _this$startThread, _this$endThread;
		if ((_this$startThread = this.startThread) === null || _this$startThread === void 0 ? void 0 : _this$startThread.thread.isMain) return this.startThread.thread;
		if ((_this$endThread = this.endThread) === null || _this$endThread === void 0 ? void 0 : _this$endThread.thread.isMain) return this.endThread.thread;
	}
	updateSize() {
		this.size = _startToEnd.subVectors(this.end, this.start).dot(this.dir);
		return this.size;
	}
	shrinkBranchToBranch() {
		if (!this.context.gridCellWidth) return;
		if (this.shrinkDiff) return;
		if (this.isMain) return;
		const mainDepth = this.startThread.thread.depth;
		const corners = this.context.loadToCornerCoreDepth + this.context.loadToCornerCoreWidth;
		const innerMuscle = this.size + mainDepth - corners;
		this.shrinkDiff = Math.min(-(innerMuscle % this.context.gridCellWidth), 0);
		this.end.addScaledVector(this.dir, this.shrinkDiff);
		this.size += this.shrinkDiff;
	}
	unshrinkBranchToBranch() {
		if (!this.context.gridCellWidth) return;
		if (!this.shrinkDiff) return;
		if (this.isMain) return;
		this.end.addScaledVector(this.dir, -this.shrinkDiff);
		this.size -= this.shrinkDiff;
		this.shrinkDiff = 0;
	}
	snapToGrid() {
		if (!this.context.gridCellWidth) return;
		if (this.startThread && this.endThread) return;
		const branch = this.startThread || this.endThread;
		if (!branch) return;
		const size = this.size + (this.bidirectional ? 0 : branch.thread.depth) - tol;
		const start = !!this.startThread;
		const diff = (size - (start === branch.right ? this.context.loadToCornerCoreWidth : this.context.loadToCornerCoreDepth) - this.context.facadeWidth + this.context.gap * .5) % this.context.gridCellWidth;
		const point = start ? this.end : this.start;
		const dir = start ? this.dir : this.nDir;
		point.addScaledVector(dir, -diff);
		this.size -= diff;
	}
};
export { ThreadData };

//# sourceMappingURL=index54.js.map